module.exports = __webpack_public_path__ + "img/icon 9@3x.52d63af3.png";